import { z } from "zod";
import { cupDateSchema, cupTeamSchema, yearSchema } from "./util";

export const cupCalendarGameGenderTypeSchema = z.enum([
	"\u041c\u0443\u0436\u0447\u0438\u043d\u044b",
	"\u0416\u0435\u043d\u0449\u0438\u043d\u044b",
]);

export const cupCalendarGameSchema = z.object({
	name: z.string(),
	team_h: cupTeamSchema,
	team_g: cupTeamSchema,
	score: z.string().nullable(),
	date: cupDateSchema.nullable(),
	set: z.string(),
	type: cupCalendarGameGenderTypeSchema,
	url: z.string(),
});
export const cupCalendarGamesSchema = z.array(cupCalendarGameSchema);

export type CupCalendarGameType = z.infer<typeof cupCalendarGameSchema>;
export type CupCalendarGameGenderType = z.infer<
	typeof cupCalendarGameGenderTypeSchema
>;
